import { render, staticRenderFns } from "./FileSidebarInfo.vue?vue&type=template&id=d616c2d6"
import script from "./FileSidebarInfo.vue?vue&type=script&lang=js"
export * from "./FileSidebarInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports